import { Text } from 'foundations-components/components/Text';
import { userInfoSync } from 'hub-http/userInfo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { H5 } from 'foundations-components/transitional/components/H5';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import SourceToDestinationDiagram from 'portability-shared-components-lib/components/shared/SourceToDestinationDiagram';
import AssetsTable from '../common/AssetsTable';
import SkippedAssetsAlert from './SkippedAssetsAlert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConfirmSelection({
  totalAssetsCount
}) {
  const {
    copyableAssets,
    selectedTargetHub,
    currentAccountName
  } = useAssetCopierContext();
  const {
    portal
  } = userInfoSync();
  if (!selectedTargetHub) {
    return null;
  }
  if (copyableAssets.length === 0) {
    return /*#__PURE__*/_jsxs(Text, {
      as: "div",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "transactions"
      }), /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.confirmSelection.noAssetsToCopy",
          options: {
            count: totalAssetsCount
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.confirmSelection.noAssetsToCopyCTA",
          options: {
            count: totalAssetsCount
          }
        })
      }), /*#__PURE__*/_jsx(SkippedAssetsAlert, {
        hideTitle: true
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "asset-copier-panel-confirm-selection",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.confirmSelectionTitle"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: currentAccountName ? 'ui-multi-account-asset-copier.panel.confirmSelection.description' : 'ui-multi-account-asset-copier.panel.confirmSelection.noSourceAccountDescription',
      options: {
        count: copyableAssets.length,
        sourceAccountName: currentAccountName,
        destinationAccountName: selectedTargetHub.name
      }
    }), /*#__PURE__*/_jsx(SkippedAssetsAlert, {}), /*#__PURE__*/_jsx(View, {
      marginBlock: "500",
      as: "div",
      children: /*#__PURE__*/_jsx(SourceToDestinationDiagram, {
        source: {
          name: currentAccountName || 'This account',
          id: portal.portal_id,
          'data-test-id': 'source-account'
        },
        destination: {
          name: selectedTargetHub.name,
          id: selectedTargetHub.hubId,
          'data-test-id': 'destination-account'
        }
      })
    }), /*#__PURE__*/_jsx(AssetsTable, {
      assets: copyableAssets
    })]
  });
}
export default ConfirmSelection;